export const AppConstants = {
    tab_details: 'Details',
    tab_viewHierarchy: 'Views & Hierarchy',
    tab_projectTypes: 'Project Types',
    tab_activityPacks: 'Activity Pack Types',
    tab_activityWorkflow: 'Activity Workflow',
    tab_reports: 'Reports',
    tab_users: 'Users',
    tab_informate: 'Joint Assured',
    tab_numberFormat: 'Number Format',
};
